module.exports = __webpack_public_path__ + "img/roll.9fa605b1.png";